import styled from "styled-components";

export const SplitsContainer = styled.div<{flex?: number}>`
  flex: ${({flex}) => flex ? flex : 5};
  display: flex;
  gap: 5px;

  @media screen and (max-height: 750px) {
    flex: 5;
  }
`;